import { useSyncExternalStore } from 'react'

type Listener = () => void

let focusedSlotId: number | null = null
let paneHighlightEnabled = true
const listeners = new Set<Listener>()

function notify() {
    listeners.forEach((listener) => listener())
}

function applyDomFocus(prev: number | null, next: number) {
    if (prev !== null && prev !== next) {
        document.getElementById(`slot-${prev}`)?.removeAttribute('data-pane-active')
    }
    if (!paneHighlightEnabled) return
    document.getElementById(`slot-${next}`)?.setAttribute('data-pane-active', 'true')
}

export function setDashboardPaneHighlightEnabled(enabled: boolean) {
    if (paneHighlightEnabled === enabled) return
    paneHighlightEnabled = enabled
    if (!enabled) {
        if (focusedSlotId !== null) {
            document.getElementById(`slot-${focusedSlotId}`)?.removeAttribute('data-pane-active')
        }
        return
    }
    if (focusedSlotId !== null) {
        document.getElementById(`slot-${focusedSlotId}`)?.setAttribute('data-pane-active', 'true')
    }
}

export function isDashboardPaneHighlightEnabled(): boolean {
    return paneHighlightEnabled
}

/** Immediate pane highlight — updates DOM before React/Redux. */
export function setDashboardFocusedSlot(slotId: number) {
    const prev = focusedSlotId
    if (prev === slotId) return
    focusedSlotId = slotId
    applyDomFocus(prev, slotId)
    notify()
}

export function syncDashboardFocusedSlotFromRedux(slotId: number | null) {
    if (slotId === null) {
        if (focusedSlotId !== null) {
            document.getElementById(`slot-${focusedSlotId}`)?.removeAttribute('data-pane-active')
            focusedSlotId = null
            notify()
        }
        return
    }
    if (focusedSlotId === slotId) return
    const prev = focusedSlotId
    focusedSlotId = slotId
    applyDomFocus(prev, slotId)
    notify()
}

export function getDashboardFocusedSlot(): number | null {
    return focusedSlotId
}

function subscribe(listener: Listener) {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

export function useIsDashboardPaneFocused(paneId: number): boolean {
    return useSyncExternalStore(
        subscribe,
        () => focusedSlotId === paneId,
        () => false
    )
}
